import React, { useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css'; // for icons
import './components/Navbar.css';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation(); // To detect route change

  useEffect(() => {
    const navbar = document.querySelector('.mortbuzz-navbar');
    const menuToggle = document.querySelector('.mortbuzz-menu-toggle');
    const menu = document.querySelector('.mortbuzz-menu');

    const toggleMenu = (e) => {
      e.stopPropagation();
      menu.classList.toggle('show');
    };

    const closeMenu = (e) => {
      if (!menu.contains(e.target) && !menuToggle.contains(e.target)) {
        menu.classList.remove('show');
      }
    };

    const handleScroll = () => {
      if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    };

    menuToggle.addEventListener('click', toggleMenu);
    document.addEventListener('click', closeMenu);
    window.addEventListener('scroll', handleScroll);

    // Close menu on route change (mobile fix)
    menu.classList.remove('show');

    return () => {
      menuToggle.removeEventListener('click', toggleMenu);
      document.removeEventListener('click', closeMenu);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]); // Re-run effect on route change

  return (
    <nav className="mortbuzz-navbar">
      <div className="mortbuzz-brand">
        <a href="/">
          <img
            src="/images/Mortbuzz-logo.png"
            alt="Logo"
            style={{ width: '150px' }}
          />
        </a>
      </div>
      <button className="mortbuzz-menu-toggle" aria-label="Toggle menu">
        &#9776;
      </button>
      <ul className="mortbuzz-menu">
        <li className="mortbuzz-dropdown">
          <a href="#">
            Apply Loan<i className="bi bi-caret-down-fill"></i>
          </a>
          <ul className="mortbuzz-dropdown-menu">
            <li>
              <a href="/apply-now">Apply Now</a>
            </li>
            <li>
              <Link to="/mortbuzz-home-loan">Mortbuzz Home Loan</Link>
            </li>
            <li>
              <Link to="/mortbuzz-loan-against-property">Loan Against Property</Link>
            </li>
            <li>
              <Link to="/business-loan">Bussiness Loan</Link>
            </li>
            <li>
              <Link to="/personal-loan">Personal Loan</Link>
            </li>
            <li>
              <Link to="/car-loan">Car Loan</Link>
            </li>
            <li>
              <Link to="/education-loan">Education Loan</Link>
            </li>
          </ul>
        </li>
        <li className="mortbuzz-dropdown">
          <a href="#">
            Products <i className="bi bi-caret-down-fill"></i>
          </a>
          <ul className="mortbuzz-dropdown-menu">
            <li>
              <Link to="/bank-interest-rates">Bank Interest Rate</Link>
            </li>
            <li>
              <Link to="/interest-rates-banks">Interest Rates</Link>
            </li>
            <li>
              <Link to="/eligibility-criteria">Eligibility</Link>
            </li>
            <li>
              <Link to="/emi-calculator">Emi Calculator</Link>
            </li>
            <li>
              <Link to="/how-to-apply">How To Apply</Link>
            </li>
            <li>
              <Link to="/faq-section">FAQ Sections</Link>
            </li>
            <li>
              <Link to="/home-loan-tax-benefits">Home Loan Tax Benefits</Link>
            </li>
            <li>
              <Link to="/mortbuzz-home-loan-offer">Home Loan Offer</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </li>
        <li className="mortbuzz-dropdown">
          <a href="#">
            Company<i className="bi bi-caret-down-fill"></i>
          </a>
          <ul className="mortbuzz-dropdown-menu">
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact us</Link>
            </li>
            <li>
              <Link to="/Career">Career Page</Link>
            </li>
            <li>
              <Link to="/society-activities">Society Activity</Link>
            </li>
          </ul>
        </li>
        <li className="mortbuzz-dropdown">
          <a href="#">
            Contact Us<i className="bi bi-caret-down-fill"></i>
          </a>
          <ul className="mortbuzz-dropdown-menu">
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </li>
        <li className="mortbuzz-dropdown">
          <a href="https://mortbuzz.in/blogs/">
            Blogs <i className="bi bi-chevron-double-down"></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
